import { axiosAiq } from 'config';

export const CAMERA_MANUAL_PATH = '/camera/manual';

// Single place building the /camera/manual request, shared by the assign-to-me/add-to-queue UI
// (useTransactionAssignementActions.jsx) and the sticky-lane "start new" flow.
export const postCameraManual = (gateCameraId, { assignToMe = true, missedDetection = false } = {}) =>
    axiosAiq.post(CAMERA_MANUAL_PATH, {
        gate_camera_id: gateCameraId,
        assign_to_me: assignToMe,
        missed_detection: missedDetection,
    });
